import React, { Component } from 'react'
import Wix from 'Wix';



class AuthGoogle extends Component {

    componentDidMount() {



       
        var objArray = {};
        var obj = window.location.search.substr(1).split('&');
        for (var i = 0; i < obj.length; i++) {
          var descriptor = obj[i];
          descriptor = descriptor.split('=');
          objArray[descriptor[0]] = descriptor[1];
        }
        console.log('objArray',objArray)
        var state = JSON.stringify({"instance" : objArray.instance, "origCompId" : objArray.origCompId ,"compId": objArray.origCompId});
        const redirect_uri = window.location.protocol + "//" + window.location.host + "/api";
          console.log('redirect_uri',redirect_uri,window.google)

     
                 //window.open('https://accounts.google.com/o/oauth2/v2/auth?gsiwebsdk=3&client_id='+_this.props.clientId+'&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile&openid.realm&redirect_uri='+redirect_uri+'&prompt=consent&state='+state+'&access_type=offline&response_type=code&include_granted_scopes=true&enable_serial_consent=true','Google login','toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=500,height=600, fullscreen=no')
    if(window.google&&window.google.accounts&&window.google.accounts.oauth2){
       const client = window.google.accounts.oauth2.initCodeClient({
            client_id: '1071120425870.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
            ux_mode: 'redirect',
            redirect_uri,
            state
          });
          client.requestCode();
    }
    }
       

    render() {
        return (
          <div>auth google</div>  
        )
    }
}


export default (AuthGoogle);


// WEBPACK FOOTER //
// ./src/settings/components/authGoogle/index.js